import React from "react"

import {
  Container,
  Titulo,
  ContainerPosts,
  ContainerTitulo,
} from "../PostLista/styles"
import PostItem from "../PostItem"

const Destaque = ({ destaque, locale }) => {
  // const { allMarkdownRemark } = useStaticQuery(
  //   graphql`
  //     query Destaque {
  //       allMarkdownRemark(
  //         sort: { fields: frontmatter___data, order: DESC }
  //         filter: {
  //           frontmatter: { destaque: { eq: true }, language: { eq: $language } }
  //         }
  //         limit: 3
  //       ) {
  //         edges {
  //           node {
  //             fields {
  //               slug
  //             }
  //             frontmatter {
  //               data(locale: "pt-br", formatString: "DD [de] MMMM [de] YYYY")
  //               tag
  //               image {
  //                 childImageSharp {
  //                   fluid(maxWidth: 600) {
  //                     ...GatsbyImageSharpFluid
  //                   }
  //                 }
  //               }
  //               titulo
  //             }
  //             timeToRead
  //           }
  //         }
  //       }
  //     }
  //   `
  // )

  // const destaque = allMarkdownRemark.edges

  return (
    <>
      <Container>
        <ContainerTitulo>
          <Titulo>
            {locale === "en" ? "Featured posts" : "Posts em destaque"}
          </Titulo>
        </ContainerTitulo>
        <ContainerPosts>
          {destaque.map(
            (
              {
                node: {
                  frontmatter: { data, tag, image, titulo },
                  fields: { slug },
                },
              },
              i
            ) => (
              <PostItem
                locale={locale}
                key={i}
                data={data}
                tag={tag}
                titulo={titulo}
                fluid={image.childImageSharp.fluid}
                redirect={slug}
              />
            )
          )}
        </ContainerPosts>
      </Container>
    </>
  )
}

export default Destaque
